import { LegendItem } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import gap from "report/common/gap";
import getTitle from "report/common/title";
import getTpye from "report/common/type";
import { PolygonAnalysisResultItem, PolygonLayerStatistic } from "../types";
import getHazardDetail from "./hazard-detail";
import getHazardOverview, {
  orderLayerStatisticsByLegend
} from "./hazard-overview";

/**
 * 生成灾害分析模块
 * 包括：灾害分析概览表 + 详细分析
 */
const getHazard = (
  t: any,
  layerStatistics: PolygonLayerStatistic[],
  analysisResult: PolygonAnalysisResultItem[],
  legendItems: LegendItem[]
): Content => {
  const content: Content[] = [];

  // 1. 大标题
  content.push(getTpye(t("report.hazard")));
  content.push(gap(30));

  // 2. 灾害分析概览表
  const overviewContent = getHazardOverview(t, layerStatistics, legendItems);
  content.push(...overviewContent);

  // 3. 页面分割
  content.push({ text: "", pageBreak: "after" });

  // 1. 大标题
  content.push(getTpye(t("report.hazard")));
  content.push(gap(30));
  content.push(getTitle(t("report.analysis")));

  // 4. 构建图例映射
  const legendMap = new Map(legendItems.map((leg) => [leg.layerId, leg]));
  const orderedLayerStatistics = orderLayerStatisticsByLegend(
    layerStatistics,
    legendItems
  );

  // 5. 按灾害层逐个生成详细分析
  for (let index = 0; index < orderedLayerStatistics.length; index += 1) {
    const stat = orderedLayerStatistics[index];
    const isLast = index === orderedLayerStatistics.length - 1;
    const legend = legendMap.get(stat.layerId);
    const hazardDetail = getHazardDetail(t, stat, legend, isLast);
    content.push(hazardDetail);
  }

  return {
    stack: content
  };
};

export default getHazard;
